 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT from '@/components/html/03_Copyright'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML01_FRONTISPIECE from '@/components/html/01_Frontispiece'
 import HTML04_DEDICATION from '@/components/html/04_Dedication'
 import HTML05_CONTENTS from '@/components/html/05_Contents'
 import HTML06_PREFACE from '@/components/html/06_PREFACE'
 import HTML07_NOTE_ON_THE_TRANSLATION from '@/components/html/07_NOTE_ON_THE_TRANSLATION'
 import HTML08_MAP from '@/components/html/08_MAP'
 import HTML09_INTRODUCTION from '@/components/html/09_INTRODUCTION'
 import HTML10_HANDBOOK from '@/components/html/10_Handbook'
 import HTML11_DISCOURSES from '@/components/html/11_Discourses'
 import HTML12_PREFACE from '@/components/html/12_PREFACE'
 import HTML13_BOOK_1 from '@/components/html/13_Book_1'
 import HTML14_BOOK_2 from '@/components/html/14_Book_2'
 import HTML15_BOOK_3 from '@/components/html/15_Book_3'
 import HTML16_BOOK_4 from '@/components/html/16_Book_4'
 import HTML17_FRAGMENTS from '@/components/html/17_Fragments'
 import HTML18_NOTES from '@/components/html/18_NOTES'
 import HTML19_TEXTUAL_NOTES from '@/components/html/19_TEXTUAL_NOTES'
 import HTML20_RECOMMENDED_READING from '@/components/html/20_RECOMMENDED_READING'
 import HTML21_INDEX from '@/components/html/21_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_Contents",
 			"name" : "html/05_Contents",
 			"component" : HTML05_CONTENTS
 		},
 		{
 			"path" : "/html/06_PREFACE",
 			"name" : "html/06_PREFACE",
 			"component" : HTML06_PREFACE
 		},
 		{
 			"path" : "/html/07_NOTE_ON_THE_TRANSLATION",
 			"name" : "html/07_NOTE_ON_THE_TRANSLATION",
 			"component" : HTML07_NOTE_ON_THE_TRANSLATION
 		},
 		{
 			"path" : "/html/08_MAP",
 			"name" : "html/08_MAP",
 			"component" : HTML08_MAP
 		},
 		{
 			"path" : "/html/09_INTRODUCTION",
 			"name" : "html/09_INTRODUCTION",
 			"component" : HTML09_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js